import React, { memo } from 'react';
import Panel from '../panel/panel.js';
import { ApiContext, StateContext } from '../utils/context.js';
var PanelList = /*#__PURE__*/memo(function PanelList() {
  var _React$useContext = React.useContext(StateContext),
      openTabIDs = _React$useContext.openTabIDs,
      selectedTabID = _React$useContext.selectedTabID,
      api = React.useContext(ApiContext),
      setting = api.optionsManager.setting,
      options = api.optionsManager.options;

  var className = setting.panellistClass + ' ' + setting[options.direction + 'Class'];

  if (options.isVertical) {
    className += ' ' + setting.verticalClass;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, openTabIDs.map(function (id) {
    return /*#__PURE__*/React.createElement(Panel, {
      key: id,
      id: id,
      selectedTabID: selectedTabID
    });
  }));
}, function () {
  return true;
});
export default PanelList;